<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in BALANCE_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-input
        v-model="listQuery.userId"
        placeholder="会员ID搜索"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="发放状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in DISTRIBUTION_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.deliveryStatus"
        placeholder="发货状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in DELIVERY_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-input
        v-model="listQuery.express"
        placeholder="快递信息（快递单号、姓名、电话）搜索"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <div style="margin-bottom: 5px">抽奖记录数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="奖品名称" align="center" prop="prizeName"></el-table-column>
      <el-table-column label="奖品类型" align="center" prop="typeName"></el-table-column>
      <el-table-column label="奖品图标" prop="iconUrl" align="center" width="100">
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.iconUrl"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="账户类型" width="200px">
        <template slot-scope="scope">
          <span>{{ getValue(ACCOUNT_TYPE, scope.row.acctType) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="200px">
        <template slot-scope="scope">
          <span>{{ getValue(DISTRIBUTION_STATUS, scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="发货状态" width="200px">
        <template slot-scope="scope">
          <span>{{ getValue(DELIVERY_STATUS, scope.row.deliveryStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="200"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            v-if="scope.row.type === 'goods'"
            @click="jumpInfo(scope.row, 'info')"
            class="comm_but_warp"
            >预览</el-button
          >

          <el-button
            type="warning"
            size="mini"
            @click="changeShipmentVisible(true, scope.row)"
            v-if="scope.row.type === 'goods'"
            >发货</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    发货-->
    <el-dialog
      title="发货"
      :visible.sync="shipmentVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="form"
        :rules="shipmentRules"
        :model="shipmentForm"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="快递公司" prop="expressId">
          <el-select
            v-model="shipmentForm.expressId"
            placeholder="请选择快递公司"
            style="width: 100%"
            class="filter-item"
            clearable
            filterable
          >
            <el-option
              v-for="item in shippingCompanyOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="expressNo">
          <el-input v-model="shipmentForm.expressNo" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeShipmentVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="saveShipmentData" :loading="shipmentBtnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRaffleRecordList, deliveryFeedback } from "@/api/raffle.js";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  BALANCE_TYPE,
  DISTRIBUTION_STATUS,
  DELIVERY_STATUS,
  ACCOUNT_TYPE
} from "@/utils/enumUtile";
import { getExpress } from "@/api/common";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    BALANCE_TYPE() {
      return BALANCE_TYPE;
    },
    DISTRIBUTION_STATUS() {
      return DISTRIBUTION_STATUS;
    },
    DELIVERY_STATUS() {
      return DELIVERY_STATUS;
    },
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        userId: null,
        type: null,
        deliveryStatus: null,
        status: null,
        express: null
      },
      shipmentBtnLoading: false,
      shipmentVisible: false,
      shipmentRules: {
        ids: [{ required: true, message: "发货编号不能为空", trigger: "change" }],
        expressId: [{ required: true, message: "快递公司不能为空", trigger: "change" }],
        expressNo: [{ required: true, message: "快递单号不能为空", trigger: "change" }]
      },
      shipmentForm: {
        ids: null,
        expressId: null,
        expressNo: null
      },
      shipmentObj: {}, // 发货的对象
      shippingCompanyOption: []
    };
  },
  created() {
    this.getList();
    this.getShippingCompany();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getRaffleRecordList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 跳转到新增 or 编辑
     */
    changeShipmentVisible(status, row = {}) {
      this.shipmentVisible = status;
      if (status) {
        this.shipmentObj = row;
        this.shipmentForm.ids = row.id;
      } else {
        this.shipmentObj = {};
        this.shipmentForm.ids = null;
        this.shipmentForm.expressId = null;
        this.shipmentForm.expressNo = null;
        this.$refs.form.resetFields();
      }
    },
    // 确定发送
    saveShipmentData() {
      const params = this.shipmentForm;
      if (!params.ids || params.ids === 0) {
        this.$notify({
          title: "提示",
          message: "实物编号发放异常，发货失败",
          type: "error",
          duration: 2000
        });
        return;
      }
      deliveryFeedback(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.$notify({
            title: "成功",
            message: "发货申请提交成功",
            type: "success",
            duration: 2000
          });
          this.changeShipmentVisible(false, {});
          this.getList();
        }
      });
    },
    /**
     * 跳转到其他页面
     */
    jumpInfo(item) {
      sessionStorage.setItem("pageState", JSON.stringify(this.listQuery));
      this.$router.push({ path: "/raffle/prizes/info/" + item.id });
    },
    /**
     * 查询发货公司
     */
    getShippingCompany() {
      getExpress().then(resp => {
        if (resp && resp.bizcode === 100) {
          this.shippingCompanyOption = resp.data;
        }
      });
    }
  }
};
</script>
<style scoped lang="scss"></style>
